import logger from "../../logger";
import { tiposTicket } from "./constants";

class Ventas {
  parseTicket = ticket => {
    let item = null;

    try {
      let items = [];
      let payment;
      let delivery;

      if (typeof ticket.body_ticket.carrito.items === "string") {
        items = JSON.parse(ticket.body_ticket.carrito.items);
      } else {
        items = ticket.body_ticket.carrito.items;
      }

      if (ticket.body_ticket.carrito.payment) {
        payment = {
          ...ticket.body_ticket.carrito.payment,
          details: JSON.parse(ticket.body_ticket.carrito.payment.details)
        };
      }

      if (ticket.body_ticket.carrito.delivery) {
        delivery = {
          ...ticket.body_ticket.carrito.delivery,
          details: JSON.parse(ticket.body_ticket.carrito.delivery.details)
        };
      }

      const carrito = {
        ...ticket.body_ticket.carrito,
        items,
        payment,
        delivery
      };

      const body_ticket = {
        ...ticket.body_ticket,
        carrito
      };

      item = {
        ...ticket,
        body_ticket
      };
    } catch (err) {
      logger(`Ventas.parseTicket.error folio ${ticket.folio_ticket}`, err);
    }

    return item;
  };

  parseTicketList = tickets => {
    const list = [];

    if (tickets) {
      for (let i = 0; i < tickets.length; i++) {
        const ticket = this.parseTicket(tickets[i]);

        if (ticket) {
          list.push(ticket);
        }
      }
    }

    return list;
  };

  filtros = tiposTicket.ventas.filtros;
}

export default Ventas;
